import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import DiscoveryFeatures from "../DiscoveryFeatures/DiscoveryFeatures";
import Coder from "../pages/Coder/Coder.js";
import DocumentViewer from "../../components/DocumentViewer/DocumentViewerWindow.js";
import EpisodeList from "../pages/EpisodeList/EpisodeList.js";
import Dashboard from "../pages/Dashboard/Dashboard.js";
import ProtectedRoute from "../../authContext/ProtecteedRoute.js";
import NoAccessPage from "../unauthorizedpage/NoAccessPage.js";
import Userindex from "../admin/users/index.js";
import AllUsers from "../admin/ApprovedUsers/AllUsers.js";
import ModuleManagement from "../admin/modulemangement/ModuleManagement.js";
import RoleManagement from "../admin/RoleManagement/RoleManagement.js";
import ManageCountry from "../admin/managecountry/ManageCountry.js";
import ManageOrganization from "../admin/manageorganization/ManageOrganization.js";
import ModulePermissions from "../admin/modulePermissions/ModulePermissions.js";
import RoleAssignments from "../admin/roleassignment/RoleAssignments.js";
import Codie from "../Codie/Codie.js";
import CodeAssist from "../CodeAssist/CodeAssistWrapper.js";
import SystemConfiguration from "../pages/SystemConfiguration/SystemConfiguration.js";
import Codeworkflow from "../Codeworkflow/Codeworkflow.js";
import HealthInformationManager from "../../components/Codeworkflow/HealthInsuranceManager/HealthInformationManager.js";
import WorkflowSettingsHome from "../pages/WorkflowSettingsHome/WorkflowSettingsHome.js";
import UserManagement from "../pages/UserManagement/UserManagement.js";
import CoderCompanion from "../codercompanion";
import WebWorkFlowMain from "../web-workflow";
import ViewDashBoard from "../codercompanion/pages/ViewDashboard.js";
import DashBoard from "../web-workflow/components/dashBoard/DashBoard.js";
import CoderView from "../Codeworkflow/CoderView/CoderView.js";
import ChatAIMainPage from "../chat-ai";
import ChatPagemainScreen from "../chat-ai/components/chatpage/ChatPageMainScreen.js"
import AuditorCodingScreen from "../Codeworkflow/AuditorCodingScreen/AuditorCodingScreen.js";
import AuditorCodeAssist from "../Codeworkflow/AuditorCodeAssistScreen/AuditorCodeAssist.js";
import AuditorView from "../Codeworkflow/AuditorView/AuditorView.js";
import PowerApp from "../Power-Apps";
import AdminDashboard from "../admin/AdminDashboard.jsx";
import HomePage from "../HomePage/HomePage";
import PasswordChangeForm from "../general/changePasswrd/ChangePasswrd.js";
import GeneralHomePage from "../general/GeneralHomePage.js";
import UploadDocuments from "../DocumentViewer/UploadDocuments.js";
import OutstandingReport from "../Codeworkflow/Reports/OutstandingReport/OutstandingReport.js";
import UploadDocumentsMain from "../DocumentViewer/UploadDocumentsMain.js";
import GlobalLoader from "../../GlobalLoader.js";
import { ChatAI } from "../../context/index.js";
import CodeSearchRecomendation from "../chat-ai/components/chatpage/CodeSearchRecomendation.js";
import GrouperSettings from "../../components/grouperSettings/GrouperSettings.js"
import ErrorDrgReport from "../Codeworkflow/Reports/ErrorDRGReport/ErrorDrgReport.js";
import CodingSupport from "../Codeworkflow/CodingSupport/CodingSupport.js";
import UserAvailability from "../Codeworkflow/UserAvailability/UserAvailability.js";
import AuditorCodeEnhance from "../Codeworkflow/AuditorView/AuditorCodeEnhance.js";
import RouteCleanupHandler from "./RouteCleanupHandler.js";
import PallasReport from "../web-workflow/PallasReport/PallasReport.js";
import CreatePatientEpisode from "../Codeworkflow/CreatePatientEpisode/CreatePatientEpisode.js";
import DRGReport from "../Codeworkflow/Reports/DRGOutliersReport/DRGReport.js"
import HACReport from "../Codeworkflow/Reports/HACReport/HACReport.js"
import CodingKpisFilter from "../Codeworkflow/Reports/CodingKpiStatsReport/CodingKpisFilter/CodingKpisFilter.js";
import CodingKpisOverview from "../Codeworkflow/Reports/CodingKpiStatsReport/CodingKpisOverview/CodingKpisOverview.js";
import CodingKpisCoderOverview from "../Codeworkflow/Reports/CodingKpiStatsReport/CodingKpisCoderOverview/CodingKpisCoderOverview.js";
import WorkflowRouter from "../CodeEnhance/WorkflowRouter.js";
// import WorkflowRouter from "../CodeEnhance/GenericTable/pages/EnhanceWorkflow/WorkflowRouter.jsx";
import DocumentViewerPatientHistrory from "../DocumentViewer/DocumentViewerPatientHistrory.js";
import EpisodeReview from "../CodeEnhance/pages/EpisodeReview/EpisodeReview.js";
import WorkflowDashBoards from "../CodeEnhance/WorkflowDashBoard/WorkflowDashboard.js"
import DataValidation from "../codercompanion/pages/DataValidation/DataValidation.js";
import CoblMissingMvdsReport from "../Codeworkflow/Reports/CoblMissingMvdsReport/CoblMissingMvdsReport.js";
import AssistSettings from "../assistSettingRules/AssistSettings.js";
import SupportRuleManagement from "../assistSettingRules/SupportRuleManagement/SupportRuleManagement.js";
import ViewRuleDatabase from "../assistSettingRules/ViewRuleDatabase/ViewRuleDatabase.js"
import CreateNewRule from "../assistSettingRules/CreateNewRule/CreateNewRule.js";
import EditActiveRule from "../assistSettingRules/EditActiveRule/EditActiveRule.js"
import TestRuleTable from "../assistSettingRules/TestRule/TestRuleTable/TestRuleTable.js";
import SubmittedRuleview from "../assistSettingRules/SubmittedView/SubmittedRuleview.js";
import TestRuleDetails from "../assistSettingRules/TestRule/TestRuleDetails/TestRuleDetails.js";
import ApprovedRuleDetails from "../assistSettingRules/ApprovedRule/ApprovedRuleDetails.js"
import PublishedRuleDetails from "../assistSettingRules/PublishedRule/PublishedRuleDetails.js"
import FailedRuleDetails from "../assistSettingRules/FailedRule/FailedRuleDetails.js"
import FailedRuleEdit from "../assistSettingRules/FailedRule/FailedRuleEdit.js";
import ArchivedRule from "../assistSettingRules/ArchiveRule/ArchivedRule.js"
import ArchivedRuleDetails from "../assistSettingRules/ArchiveRule/ArchivedRuleDetails/ArchivedRuleDetails.js"
import ArchivedEditRule from "../assistSettingRules/ArchiveRule/ArchiveEditRule/ArchivedEditRule.js"
import ViewActiveRule from "../assistSettingRules/EditActiveRule/ViewActiveRule/ViewActiveRule.js";

const Routespage = ({ isRowClicked, setIsRowClicked }) => {
  // console.log(isRowClicked, "seeroutes");
  const [docuType, setDocType] = useState(false);
  return (
    <>
    {/* <GlobalLoader/> */}
          {/* <RouteCleanupHandler/> */}
    <Routes>
      <Route path="/no-access" element={<NoAccessPage />} />
      <Route path="/" element={<HomePage />} />
      {/* <Route path="/" element={<DiscoveryFeatures />} /> */}
      <Route
        path="/coder"
        element={
          <ProtectedRoute requiredPermissions={["Coder", "admin"]}>
            <Coder />
          </ProtectedRoute>
        }
      />

      <Route
        path="/Code-Workflow"
        element={
          <ProtectedRoute requiredPermissions={["CodeWorkflow", "admin"]}>
            <Codeworkflow />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Pallas-Report"
        element={
          <ProtectedRoute>
             <PallasReport/>
          </ProtectedRoute>
        }
      />
         <Route
        path="/Review-Enhance-Workflow"
        element={
          <ProtectedRoute requiredPermissions={["Code Enhance", "admin"]}>
             <WorkflowRouter/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/document-viewer"
        element={
          <ProtectedRoute requiredPermissions={["DocumentViewer", "admin"]}>
            <DocumentViewer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/patient-history-viewer"
        element={
          <ProtectedRoute requiredPermissions={["DocumentViewer", "admin"]}>
            <DocumentViewerPatientHistrory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Episode-list"
        element={
          <ProtectedRoute requiredPermissions={["EpisodeList", "admin"]}>
            <EpisodeList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute requiredPermissions={["Dashboard", "admin"]}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
            <Route
        path="/Pallas-Report"
        element={
          <ProtectedRoute>
             <PallasReport/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute requiredPermissions={["admin"]}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute requiredPermissions={["admin"]}>
            <Userindex />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Approved-Users"
        element={
          <ProtectedRoute requiredPermissions={["admin"]}>
            <AllUsers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/modules"
        element={
          <ProtectedRoute requiredPermissions={["admin"]}>
            <ModuleManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/roles"
        element={
          <ProtectedRoute requiredPermissions={["admin"]}>
            <RoleManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/countries"
        element={
          <ProtectedRoute requiredPermissions={["admin"]}>
            <ManageCountry />
          </ProtectedRoute>
        }
      />
      <Route
        path="/organizations"
        element={
          <ProtectedRoute requiredPermissions={["admin"]}>
            <ManageOrganization />
          </ProtectedRoute>
        }
      />
      <Route
        path="/module-permissions"
        element={
          <ProtectedRoute requiredPermissions={["admin"]}>
            <ModulePermissions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/role-assignments"
        element={
          <ProtectedRoute requiredPermissions={["admin"]}>
            <RoleAssignments />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/codie"
        element={
          <ProtectedRoute requiredPermissions={["Codie", "admin"]}>
            <Codie />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/system-configuration"
        element={
          <ProtectedRoute>
            <SystemConfiguration />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Code-Assist"
        element={
          <ProtectedRoute requiredPermissions={["Code Assist", "admin"]}>
            <CodeAssist />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Code-Assist-Episode-list"
        element={
          <ProtectedRoute requiredPermissions={["EpisodeList", "admin"]}>
            <EpisodeList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Workflow-settings"
        element={
          <ProtectedRoute>
            <WorkflowSettingsHome />
          </ProtectedRoute>
        }
      />
      <Route
        path="/User-Management"
        element={
          <ProtectedRoute>
            <UserManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/HCP-File-Processor"
        element={
          <ProtectedRoute>
            <DataValidation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Discovery"
        element={
          <ProtectedRoute>
            <CoderCompanion />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Workflow"
        element={
          <ProtectedRoute>
            <WebWorkFlowMain
              isRowClicked={isRowClicked}
              setIsRowClicked={setIsRowClicked}
            />
          </ProtectedRoute>
        }
      />
      <Route
        path="/viewdashboard"
        element={
          <ProtectedRoute>
            <ViewDashBoard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/auditor-enhance-workflow"
        element={
          <ProtectedRoute>
            <AuditorCodeEnhance/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/workflow-dashboard"
        element={
          <ProtectedRoute>
            <WorkflowDashBoards/>
          </ProtectedRoute>
        }
      />
      <Route
  path="/Review-Enhance-Workflow/:episodeId?"
  element={
    <ProtectedRoute requiredPermissions={["Code Enhance", "admin"]}>
      <WorkflowRouter />
    </ProtectedRoute>
  }
/>
      <Route
        path="/Coder-Workspace"
        element={
          <ProtectedRoute>
            <CoderView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Codie"
        element={
          <ProtectedRoute  requiredPermissions={["Codie", "admin"]}>
            {(process.env.REACT_APP_FLAG_DEV||process.env.REACT_APP_FLAG_FIJI_DEV ||process.env.REACT_APP_FLAG_INTERNAL||process.env.REACT_APP_FLAG_DEV||process.env.REACT_APP_FLAG_HEALTHECARE)?<ChatPagemainScreen />:<ChatAIMainPage/>}
          </ProtectedRoute>
        }
      />
        <Route
        path="/ChatAi"
        element={
            <ProtectedRoute requiredPermissions={["Codie", "admin"]}>
             <ChatAIMainPage />
            </ProtectedRoute>

        }
      />
      <Route
        path="/SearchCodingAdvice"
        element={
            <CodeSearchRecomendation />
        }
      />
      <Route
        path="/Auditor-Coding-Screen"
        element={
          <ProtectedRoute>
            <AuditorCodingScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Auditor-CodeAssist-Screen"
        element={
          <ProtectedRoute>
            <AuditorCodeAssist />
          </ProtectedRoute>
        }
      />
      <Route
        path="/HIM-Workspace"
        element={
          <ProtectedRoute>
            <HealthInformationManager />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Auditor-Workspace"
        element={
          <ProtectedRoute>
            <AuditorView setIsRowClicked={setIsRowClicked}/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/General"
        element={
          <ProtectedRoute>
            {/* <PasswordChangeForm/> */}
            <GeneralHomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ChangePassword"
        element={
          <ProtectedRoute>
            <PasswordChangeForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Grouper-settings"
        element={
          <ProtectedRoute>
            <GrouperSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path="powerapp"
        element={
          <ProtectedRoute requiredPermissions={["AuditRuleSettings", "admin"]}>
            <PowerApp />
          </ProtectedRoute>
        }
      />
      <Route
        path="/upload-document"
        element={
          <ProtectedRoute requiredPermissions={["Coder", "admin"]}>
            <UploadDocumentsMain docuType={docuType} setDocType={setDocType} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings-upload-document"
        element={
          <ProtectedRoute requiredPermissions={["Coder", "admin"]}>
            <UploadDocumentsMain docuType={docuType} setDocType={setDocType} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/upload-type-document"
        element={
          <ProtectedRoute requiredPermissions={["Coder", "admin"]}>
            <UploadDocuments docuType={docuType} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings-upload-type-document"
        element={
          <ProtectedRoute requiredPermissions={["Coder", "admin"]}>
            <UploadDocuments docuType={docuType} />
          </ProtectedRoute>
        }
      />
      <Route
        path="/outstanding-report"
        element={
          <ProtectedRoute>
            <OutstandingReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/error-drg-report"
        element={
          <ProtectedRoute>
            <ErrorDrgReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/missing-mvds-report"
        element={
          <ProtectedRoute>
            <CoblMissingMvdsReport/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hac-report"
        element={
          <ProtectedRoute>
            <HACReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/drg-outlier-report"
        element={
          <ProtectedRoute>
            <DRGReport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/coding-support"
        element={
          <ProtectedRoute>
            <CodingSupport />
          </ProtectedRoute>
        }
      />

      <Route
        path="/User-Availability"
        element={
          <ProtectedRoute>
            <UserAvailability />
          </ProtectedRoute>
        }
      />
       <Route
        path="/Create-Patient-Episode"
        element={
          <ProtectedRoute>
            <CreatePatientEpisode />
          </ProtectedRoute>
        }
      />
       <Route
        path="/coding-kpis-report"
        element={
          <ProtectedRoute>
            <CodingKpisOverview />
          </ProtectedRoute>
        }
      />
       <Route
        path="/coding-kpis-overview"
        element={
          <ProtectedRoute>
            <CodingKpisOverview />
          </ProtectedRoute>
        }
      />
       <Route
        path="/codingkpis-coder-report"
        element={
          <ProtectedRoute>
            <CodingKpisCoderOverview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/assist-settings"
        element={
          <ProtectedRoute>
            <AssistSettings />
          </ProtectedRoute>
        }
        />
       <Route
        path="/support-rule-management"
        element={
          <ProtectedRoute>
            <SupportRuleManagement />
          </ProtectedRoute>
        }
        />
        <Route
        path="/view-rule-database"
        element={
          <ProtectedRoute>
            <ViewRuleDatabase/>
          </ProtectedRoute>
        }
        />
         <Route
        path="/create-new-rule"
        element={
          <ProtectedRoute>
            <CreateNewRule/>
          </ProtectedRoute>
        }
        />
        <Route
        path="/edit-active-rule"
        element={
          <ProtectedRoute>
            <EditActiveRule/>
          </ProtectedRoute>
        }
        />
         <Route
        path="/test-rule-table"
        element={
          <ProtectedRoute>
            <TestRuleTable/>
          </ProtectedRoute>
        }
        />
        <Route
        path="/submit-rule-view"
        element={
          <ProtectedRoute>
            <SubmittedRuleview/>
          </ProtectedRoute>
        }
        />
        <Route
        path="/test-rule-details"
        element={
          <ProtectedRoute>
            <TestRuleDetails/>
          </ProtectedRoute>
        }
        />
          <Route
        path="/approved-rule-details"
        element={
          <ProtectedRoute>
            <ApprovedRuleDetails/>
          </ProtectedRoute>
        }
        />
         <Route
        path="/published-rule-details"
        element={
          <ProtectedRoute>
            <PublishedRuleDetails/>
          </ProtectedRoute>
        }
        />
       <Route
        path="/failed-rule-details"
        element={
          <ProtectedRoute>
            <FailedRuleDetails/>
          </ProtectedRoute>
        }
        />
         <Route
        path="/failed-rule-edit"
        element={
          <ProtectedRoute>
            <FailedRuleEdit/>
          </ProtectedRoute>
        }
        />
         <Route
        path="/archived-rule"
        element={
          <ProtectedRoute>
            <ArchivedRule/>
          </ProtectedRoute>
        }
        />
        <Route
        path="/archived-rule-details"
        element={
          <ProtectedRoute>
            <ArchivedRuleDetails/>
          </ProtectedRoute>
        }
        />
           <Route
        path="/archived-edit-rule"
        element={
          <ProtectedRoute>
            <ArchivedEditRule/>
          </ProtectedRoute>
        }
        />
        <Route
        path="/view-active-rule"
        element={
          <ProtectedRoute>
            <ViewActiveRule/>
          </ProtectedRoute>
        }
        />
    </Routes>
    
    </>
  );
};

export default Routespage;
